import { graphql, useStaticQuery } from 'gatsby'

export const StrapiTopBarQuery = graphql`
  query StrapiTopBarQuery {
    strapiHeader {
      id
      TopBarInfoSlider {
        id
        testId
        TopBarInfoSlider {
          id
          testId
          Title
          DisplaysOnList {
            strapi_json_value
          }
          UtmCampaigns
          UtmSlide {
            id
            testId
            TopBarInfo {
              id
              testId
              Title
              Header
              Icon {
                ...StrapiImageFragment
              }
              SecondaryLink {
                Link {
                  ...StrapiLinkFragment
                }
              }
              InfoBarLink {
                Link {
                  ...StrapiLinkFragment
                }
              }
              BackgroundColor {
                ColorHex
              }
              TextColor {
                ColorHex
              }
              ArrowColor {
                ColorHex
              }
              DisableUnderline
              Variant
            }
          }
          TopBarInfo {
            id
            testId
            TopBarInfo {
              id
              testId
              Title
              Header
              Icon {
                ...StrapiImageFragment
              }
              SecondaryLink {
                Link {
                  ...StrapiLinkFragment
                }
              }
              InfoBarLink {
                Link {
                  ...StrapiLinkFragment
                }
              }
              BackgroundColor {
                ColorHex
              }
              TextColor {
                ColorHex
              }
              ArrowColor {
                ColorHex
              }
              DisableUnderline
              Variant
              Alignment
              Countdown {
                Countdown {
                  Title
                  ExpirationDate
                  BackgroundColor {
                    ColorHex
                  }
                  SecondaryBackgroundColor {
                    ColorHex
                  }
                  BorderColor {
                    ColorHex
                  }
                  TextColor {
                    ColorHex
                  }
                  RainbowOuterBorder
                  DesktopSpacing {
                    BottomPadding
                    TopPadding
                  }
                  MobileSpacing {
                    BottomPadding
                    TopPadding
                  }
                  DisplayTime
                  AccessibilityMessage
                }
              }
            }
          }
        }
      }
    }
  }
`

const useStaticTopBarQuery = () => {
  const data = useStaticQuery(StrapiTopBarQuery)

  return data
}

export default useStaticTopBarQuery
